import wx from 'weixin-js-sdk'
import {user_jssdk} from '../utils/api'


export const wx_fun = () => {
    // let url = "";
    // let ua = navigator.userAgent.toLowerCase();
    // // 处理ios 分享链接问题
    // if (/iphone|ipad|ipod/.test(ua)) {
    //     url = location.href.split("#")[0];
    // } else if (/android/.test(ua)) {
    //     // url = location.href;
    //     url = location.href.split("#")[0];
    // }
    let url = get_url()
    
    user_jssdk({ back_url: url, js_api:["updateAppMessageShareData","updateTimelineShareData","scanQRCode"] })
        .then(res => {
            // console.log(res);
            wx.config({
                debug: res.data.debug, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                appId: res.data.appId, // 必填，公众号的唯一标识
                timestamp: res.data.timestamp, // 必填，生成签名的时间戳
                nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
                signature: res.data.signature, // 必填，签名，见附录1
                jsApiList:  res.data.jsApiList// 必填，需要使用的JS接口列表，所有JS接口列表见附录2
            });

            // wx.ready(function () {
            //     // 需在用户可能点击分享按钮前就先调用 onMenuShareTimeline onMenuShareTimeline
            //     wx.onMenuShareAppMessage({
            //         title: data.title,  // 分享标题
            //         desc: data.desc,   // 分享描述
            //         link: url,   // 分享链接，链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            //         imgUrl: data.imgUrl, // 分享图标
            //         success: function () {  // 设置成功
            //         console.log("分享方法");
            //         }
            //     });
            // });
        })
        .catch(err => { console.log(err); });
}

export const get_url = () => {

    let url = "";
    let ua = navigator.userAgent.toLowerCase();
    // 处理ios 分享链接问题
    if (/iphone|ipad|ipod/.test(ua)) {
        url = location.href.split("#")[0];
    } else if (/android/.test(ua)) {
        // url = location.href;
        url = location.href.split("#")[0];
    }
    return url
}

export const share = data => {

    let url = get_url()
    wx.ready(function () {
        // 需在用户可能点击分享按钮前就先调用 onMenuShareAppMessage onMenuShareTimeline
        wx.updateAppMessageShareData({
            title: data.title,  // 分享标题
            desc: '',   // 分享描述
            link: url,   // 分享链接，链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: data.imgUrl, // 分享图标
            success: function () {  // 设置成功
            // console.log("分享朋友");
            }
        });

        wx.updateTimelineShareData({
            title: data.title,  // 分享标题
            desc: '',   // 分享描述
            link: url,   // 分享链接，链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: data.imgUrl, // 分享图标
            success: function () {  // 设置成功
            // console.log("分享朋友圈");
            }
        });

    });
}

export const scanCode = data => {

    wx.ready( () => {
        // 9.1.2 扫描二维码并返回结果
        document.querySelector('#scanQRCode').onclick = function () {
            wx.scanQRCode({
                needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
                scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
                success: function (res) {
                    let result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
                    // console.log(result);    
                    // iv.toIndex(result); //注：扫码返回结果后，如果需要对当前页面赋值等操作，需要另写函数
                    window.location.assign(result)
                },
                fail:function (err) {
                    console.log(err)
                    if (err.errMsg.indexOf('function_not_exist') > 0) {
                        // console.log('当前版本过低，请进行升级');
                        console.log('网络错误！');
                    }
                }
            });
        }

    })
}



// WEBPACK FOOTER //
// ./src/utils/vxshare.js